module.exports = __webpack_public_path__ + "img/83.489ed84a.svg";